<template>
    <Modal v-model="modal" :width="85" :title="title" @on-visible-change="modalTrigger($event)" :footer-hide="true">
        <Form :model="basisFormData" :label-width="120" label-colon="：" class="basicForm">
            <Row>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="客户全称"><Input v-model="basisFormData.custName" placeholder=""></Input></FormItem></Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="客户英文名"><Input v-model="basisFormData.englishName" placeholder=""></Input></FormItem></Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="法人代表"><Input v-model="basisFormData.legalPerson" placeholder=""></Input></FormItem></Col>
            </Row>
            <Row>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="注册资金"><InputNumber class="w-100" v-model="basisFormData.registerCapital"></InputNumber></FormItem></Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="业务范围"><Input v-model="basisFormData.businessScope" placeholder=""></Input></FormItem></Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}">
                    <FormItem label="是否上市">
                        <i-switch v-model="basisFormData.listed" size="large">
                            <span slot="open">是</span>
                            <span slot="close">否</span>
                        </i-switch>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col :sm="{ span: 24}" :xl="{ span: 12}"><FormItem label="备注"><Input v-model="basisFormData.description" show-word-limit type="textarea" :rows="5" /></FormItem></Col>
            </Row>
            <Row>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="注册货币类型"><Input v-model="basisFormData.currencyType" placeholder=""></Input></FormItem></Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="国家"><Input v-model="basisFormData.country" placeholder=""></Input></FormItem></Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="地区"><Input v-model="basisFormData.region" placeholder=""></Input></FormItem></Col>
            </Row>
            <Row>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="行业"><Input v-model="basisFormData.industry" placeholder=""></Input></FormItem></Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="电话"><Input v-model="basisFormData.phone" placeholder=""></Input></FormItem></Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="传真"><Input v-model="basisFormData.fax" placeholder=""></Input></FormItem></Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="邮箱"><Input v-model="basisFormData.email" placeholder=""></Input></FormItem></Col>
            </Row>
            <Row>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="员工数"><InputNumber class="w-100" v-model="basisFormData.staffCount"></InputNumber></FormItem></Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="联络人"><Input v-model="basisFormData.contacts" placeholder=""></Input></FormItem></Col>
                <Col :sm="{ span: 12}" :xl="{ span: 6}"><FormItem label="地址"><Input v-model="basisFormData.addr" placeholder=""></Input></FormItem></Col>
            </Row>
        </Form>
    </Modal>
</template>

<script>
import api from '@/api/index';
export default {
    name: 'custCreateAndEdit',
    props: {
        createShow: Boolean,
        createId: String,
        createTitle: String
    },
    data() {
        return {
            modal: this.createShow,
            title: '',
            basisFormData: {
                custName: '',
                englishName: '',
                legalPerson: '',
                registerCapital: 0,
                businessScope: '',
                listed: false,
                description: '',
                currencyType: '',
                country: '',
                region: '',
                industry: '',
                phone: '',
                fax: '',
                email: '',
                staffCount: 0,
                contacts: '',
                addr: ''
            }
        };
    },
    watch: {
        createShow(vel, oldVel) {
            this.modal = vel;
        },
        createId(vel, oldVel) {
            this.id = vel;
        },
        createTitle(vel, oldVel) {
            this.title = vel;
        }
    },
    methods: {
        async getBasicDetail() {
            let res = await api.getustDetail(this.id);
            this.financeData = res.data.financialReportList;
            this.financeDateList = [];
            for (const item in res.data.financialReportList) {
                this.financeDateList.push({ value: res.data.financialReportList[item].year });
            }
            this.basisFormData = res.data;
        },
        modalTrigger(val) {
            this.$emit('createShowChange', val);
        }
    }
};
</script>
<style lang="scss" scoped>
.w-100 {
    width: 100%;
}
.matterTable-box {
    height: 500px;
}
</style>
<style scoped>
.basicForm >>> .ivu-form-item {
    margin-bottom: 10px;
}
</style>
